import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../providers/user-service/user.service';

@Component({
  templateUrl: './import-encrypted-mnemonic.page.html',
  styleUrls: ['./import-encrypted-mnemonic.page.scss']
})
export class ImportEncryptedMnemonic implements OnInit {
    public mnemonic;
    private pbk = 'MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAuppGuik9HiiKO1sE0cq4ZECnamRV0Tib8zfQoe+Z7Lg1D8SM2YOhwGYeTPpdTNKQW/YCdIIQUwCSYKk89lwE1VlUWJk88dXDx34ohKBfJjx6R/q2+GiGXI2xhyJoQgHKSIemiBINPmhk9k40gHpdqHJiXdii1SKwiSBS2utz18G6+fmsmPqj7u7yWGZVqcVXnQHMF3OARN+Sbifm3RIFNyT2TcK7Gw1IqUEu4S/msmUnIiyRDX7ZXniwpCQqbbsygI9TpjkioTX9plL42hb26sEarZvNPehxTMbP2lJTVU92224ZYyH097K7lKwWkN0A1Jqg4A227/yc+Oi4FyXGi59WCN5tD1VyuLVP3ovFNSVMlNVvKeyxCD1EouJPDeqIVkMDcg23IGjjVDhZD2be052vhFaTH9XPYxhcixPBXsQWrpxQtsV/ClXB4QEpoPTbJRFkNJJdJyEk3g9Wa1Pu/Dzwy6OHC6CyGA24iCIDUr0vdSMvLUJArat1EpaTv08lrrIOSq8gDPePF4rTDOg422ddmeFEVKaMEyWKKDpE8dqivRhevJe3xcjyz26ACtBJN1Fd78qcEMoLX+r0TuniZfLu4cUIN1rszl+ptijbttttLnoxMoITE6trlRzeEOpkRoHpa9JwuPyUdeRLgU82OgjE+/ScDZW2lR1KF2ZYNPkCAwEAAQ==';
    private pk = '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';

    constructor (private activatedRoute: ActivatedRoute,
                private walletService: UserService
    ) {
    }

    private encryptAlgorithm = {
      name: 'RSA-OAEP',
      modulusLength: 4096,
      publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
      hash: 'sha-512'
    };

    async ngOnInit () {
      const { mnemonic } = this.activatedRoute
        .snapshot.queryParams;
      if (mnemonic) {
        const mnemonicDecypher = await this.decrypt(mnemonic);
        this.mnemonic = mnemonicDecypher;
      }
    }

    private async decrypt (ciphertext) {
      function removeLines (str) {
        return str.replace('\n', '');
      }

      function base64ToArrayBuffer (b64) {
        var byteString = window.atob(b64);
        var byteArray = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
        }

        return byteArray;
      }

      function pemToArrayBuffer (pem) {
        var b64Lines = removeLines(pem);
        var b64Prefix = b64Lines.replace('-----BEGIN PRIVATE KEY-----', '');
        var b64Final = b64Prefix.replace('-----END PRIVATE KEY-----', '');

        return base64ToArrayBuffer(b64Final);
      }

      const privateKeyCrypto = await window.crypto.subtle.importKey(
        'pkcs8',
        pemToArrayBuffer(this.pk),
        this.encryptAlgorithm,
        true,
        ['decrypt']
      );

      const decrypted = await window.crypto.subtle.decrypt(
        this.encryptAlgorithm,
        privateKeyCrypto,
        Buffer.from(ciphertext, 'hex')
      );

      return new TextDecoder().decode(decrypted);
    }
}
